// DOCUMENTATION
// This component adds two divs, one that applies universal page padding and the
// other that adds centering and max-width to content. This will apply a consistent
// padding left and right across devices and screen sizes.
//
// You can apply this at the page level if the entire page content block needs
// wrapping with universal styles applied to this single wrapper. You can apply
// this at the component level if components within a page need different styles
// applied to the full-width, or SectionWrapper, div. For example, components on a
// page might require a full page width border or a background color that spans the
// full page width.
//
// You should not add Wrapper within a page or component whose parent includes
// another Wrapper. Meaning, Wrappers should not be nested within other Wrappers.
//
// You should add small, medium, or large as a size attribute. Medium is default.

import * as React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
  style?: {};
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  inset?: boolean;
  fullWidthMobile?: boolean;
}

/**
 * @deprecated Use the Container component from ui
 */
const Wrapper: React.ForwardRefExoticComponent<
  React.PropsWithChildren<Props & React.RefAttributes<HTMLDivElement>>
> = React.forwardRef<HTMLDivElement, Props>(
  ({ children, className, fullWidthMobile, inset, style, size = 'medium' }, ref) => {
    return (
      <div
        className={clsx('SectionWrapper', className, `SectionWrapper--${size}`, {
          'SectionWrapper--inset': inset,
          'has-full-width': fullWidthMobile,
        })}
        style={style}
        ref={ref}
      >
        <div className="SectionContent">{children}</div>
      </div>
    );
  }
);

export default Wrapper;
